import type { SendViewItemListConfig } from './types'
import { GtmItemListId } from './types'
import { parseKftEventToGtmItemListItem } from './parsers/parseKftEventToGtmItemListItem'

export const sendViewItemListConfig: SendViewItemListConfig = {
  [GtmItemListId.GeneralPageRecommendedEvents]: {
    listName: 'General Page Recommended Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageTopEvents]: {
    listName: 'General Page Top Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageGiftcardEvents]: {
    listName: 'General Giftcard Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageTopGiftIdeas]: {
    listName: 'General Page Top Gift Ideas',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageNewEvents]: {
    listName: 'General Page New Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageLastViewedEvents]: {
    listName: 'General Page Last Viewed Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageKits]: {
    listName: 'General Page Kits',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.KitsPageKits]: {
    listName: 'Kits Page Kits',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarClasses]: {
    listName: 'Event Page Similar Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarClassesTop]: {
    listName: 'Event Page Similar Classes on Top',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSameSupplierClasses]: {
    listName: 'Event Page Same Supplier Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarOnlineClasses]: {
    listName: 'Event Page Similar Online Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GiftcardPageGiftcardEvents]: {
    listName: 'Giftcard Page Giftcard Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.MagazineArticlePageSupplierClasses]: {
    listName: 'Magazine Article Page Supplier Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.MagazineArticlePageVideoClasses]: {
    listName: 'Magazine Article Page Video Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.TeameventPageTopEvents]: {
    listName: 'Teamevent Page Top Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.ReviewSuccessPageRecommendedEvents]: {
    listName: 'Review Success Page Recommended Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPagePromotions]: {
    listName: 'General Page Promotions',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.SearchPage]: {
    listName: 'Search',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.CategoryPage]: {
    listName: 'Category page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.CityPage]: {
    listName: 'City page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.CityCategoryPage]: {
    listName: 'City Category page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.TagPage]: {
    listName: 'Tag page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.TeameventPage]: {
    listName: 'Teamevent page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.PartnerPage]: {
    listName: 'Partner page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.SubdomainPage]: {
    listName: 'Subdomain page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.ErrorPage]: {
    listName: 'Error page',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.FederatedSearchHomepage]: {
    listName: 'Federated Search Homepage',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.FederatedSearchHomepageLastViewed]: {
    listName: 'Federated Search Homepage Last Viewed',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.FederatedSearchNavbar]: {
    listName: 'Federated Search Navbar',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.FederatedSearchNavbarLastViewed]: {
    listName: 'Federated Search Navbar Last Viewed',
    parser: parseKftEventToGtmItemListItem,
  },
  // Example of a different type of data below
  // [GtmItemListId.GeneralPageCategories]: {
  //   listName: "General Page Categories",
  //   parser: parseKftCategoryToGtmItemListItem,
  // },
}
